import React, { useEffect, useRef } from "react";
import Info from "../../../Components/About/Info";
import Experience from "../../../Components/Experience/Experience";
import ProjectN from "../../../Components/Projects/ProjectN";
import BlogDesktop from "../../../Components/Blogs/BlogDesktop/BlogDesktop";
import StravaFooter from "../../../Components/Strava/StravaFooter";
import Skills from "../../../Components/Skills/Skills";
import "./MainContent.css";

const MainContent = ({ isMobileView, scrollToTarget, onSectionChange, onProjectSelect }) => {
  const containerRef = useRef(null);
  const isProgrammaticallyScrolling = useRef(false);
  const scrollTimeoutRef = useRef(null);

  const containerClass = `main-content ${
    isMobileView ? "" : "animate-desktop"
  }`;

  useEffect(() => {
    if (!scrollToTarget || !containerRef.current) return;

    const sectionElement = document.querySelector(scrollToTarget);
    if (sectionElement) {
      isProgrammaticallyScrolling.current = true;

      containerRef.current.scrollTo({
        top: sectionElement.offsetTop,
        behavior: "smooth",
      });

      clearTimeout(scrollTimeoutRef.current);
      scrollTimeoutRef.current = setTimeout(() => {
        isProgrammaticallyScrolling.current = false;
      }, 1000);
    }
  }, [scrollToTarget]);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const handleIntersect = (entries) => {
      if (isProgrammaticallyScrolling.current) return;

      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          onSectionChange(`#${entry.target.id}`);
        }
      });
    };

    const observer = new IntersectionObserver(handleIntersect, {
      root: container,
      rootMargin: "-50% 0px -50% 0px",
      threshold: 0,
    });

    const sections = container.querySelectorAll(".scroll-section");
    sections.forEach((section) => {
      observer.observe(section);
    });

    return () => {
      sections.forEach((section) => {
        observer.unobserve(section);
      });
      clearTimeout(scrollTimeoutRef.current);
    };
  }, [onSectionChange]);

  const Divider = ({ label }) => (
    <div className="section-divider">
      <span className="section-divider-label">— {label} —</span>
    </div>
  );

  return (
    <div className={containerClass} ref={containerRef}>
      <div id="about" className="section scroll-section">
        <Info />
      </div>
      <Divider label="experience" />
      <div id="experience" className="section-experience scroll-section">
        <Experience />
      </div>
      <Divider label="skills" />
      <div id="skills" className="section-skills scroll-section">
        <Skills />
      </div>
      <Divider label="projects" />
      <div id="projects" className="section-projects scroll-section">
        <ProjectN onProjectSelect={onProjectSelect} />
      </div>
      <Divider label="blog" />
      <div id="blogs" className="section-blogs scroll-section">
        <BlogDesktop />
      </div>
      <div className="section-strava">
        <StravaFooter />
      </div>
    </div>
  );
};

export default MainContent;
